/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Jump_Confirmation_TitleInputs */

const en_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start from ${i?.number} minutes`)
};

const ar_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ابدأ من الدقيقة ${i?.number}`)
};

const de_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bei ${i?.number} Min. starten`)
};

const es_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empezar en ${i?.number} min`)
};

const fr_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencer à ${i?.number} min`)
};

const it_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia da ${i?.number} min`)
};

const ja_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}分から開始`)
};

const ko_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}분부터 시작`)
};

const pt_br_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começar a partir de ${i?.number} min`)
};

const ru_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начать с ${i?.number} мин`)
};

const th_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มจาก ${i?.number} นาที`)
};

const tr_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} dakikadan başla`)
};

const zh_cn_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从 ${i?.number} 分钟开始`)
};

const zh_tw_jump_confirmation_title = /** @type {(inputs: Jump_Confirmation_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`從 ${i?.number} 分鐘開始`)
};

/**
* | output |
* | --- |
* | "Start from {number} minutes" |
*
* @param {Jump_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const jump_confirmation_title = /** @type {((inputs: Jump_Confirmation_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jump_Confirmation_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jump_confirmation_title(inputs)
	if (locale === "ar") return ar_jump_confirmation_title(inputs)
	if (locale === "de") return de_jump_confirmation_title(inputs)
	if (locale === "es") return es_jump_confirmation_title(inputs)
	if (locale === "fr") return fr_jump_confirmation_title(inputs)
	if (locale === "it") return it_jump_confirmation_title(inputs)
	if (locale === "ja") return ja_jump_confirmation_title(inputs)
	if (locale === "ko") return ko_jump_confirmation_title(inputs)
	if (locale === "pt_br") return pt_br_jump_confirmation_title(inputs)
	if (locale === "ru") return ru_jump_confirmation_title(inputs)
	if (locale === "th") return th_jump_confirmation_title(inputs)
	if (locale === "tr") return tr_jump_confirmation_title(inputs)
	if (locale === "zh_cn") return zh_cn_jump_confirmation_title(inputs)
	return zh_tw_jump_confirmation_title(inputs)
});